// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Lato", sans-serif;
}

.sidebar {
  top: auto;
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  left: 0;
  background-color: whitesmoke;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

  .sidebar a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 15px;
    color: #818181;
    display: block;
    transition: 0.3s;
  }

    .sidebar a:hover {
      color: darkslategrey;
    }

  .sidebar .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
  }

.openbtn {
  font-size: 20px;
  cursor: pointer;
  background-color: #111;
  color: white;
  padding: 10px 15px;
  border: none;
}

  .openbtn:hover {
    background-color: #444;
  }

#main {
  transition: margin-left .5s;
  padding: 16px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidebar {
    padding-top: 15px;
  }

    .sidebar a {
      font-size: 18px;
    }
}


.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #fff;
  background-color: #17a2b8;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link {
  color: #818182;
}
.card-header {
  padding: 4px 10px 2px 10px;
}

.card-body {
    padding : 8px !important; 
}
`, "",{"version":3,"sources":["webpack://./src/app/offer/adminfunctions/adminfunctions.component.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,UAAU;EACV,OAAO;EACP,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;EAEE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;;IAEE;MACE,oBAAoB;IACtB;;EAEF;IACE,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;AAEF;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;EAEE;IACE,sBAAsB;EACxB;;AAEF;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA,gIAAgI;AAChI;EACE;IACE,iBAAiB;EACnB;;IAEE;MACE,eAAe;IACjB;AACJ;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["body {\r\n  font-family: \"Lato\", sans-serif;\r\n}\r\n\r\n.sidebar {\r\n  top: auto;\r\n  height: 100%;\r\n  width: 0;\r\n  position: fixed;\r\n  z-index: 1;\r\n  left: 0;\r\n  background-color: whitesmoke;\r\n  overflow-x: hidden;\r\n  transition: 0.5s;\r\n  padding-top: 60px;\r\n}\r\n\r\n  .sidebar a {\r\n    padding: 8px 8px 8px 32px;\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n    color: #818181;\r\n    display: block;\r\n    transition: 0.3s;\r\n  }\r\n\r\n    .sidebar a:hover {\r\n      color: darkslategrey;\r\n    }\r\n\r\n  .sidebar .closebtn {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 25px;\r\n    font-size: 36px;\r\n    margin-left: 50px;\r\n  }\r\n\r\n.openbtn {\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  background-color: #111;\r\n  color: white;\r\n  padding: 10px 15px;\r\n  border: none;\r\n}\r\n\r\n  .openbtn:hover {\r\n    background-color: #444;\r\n  }\r\n\r\n#main {\r\n  transition: margin-left .5s;\r\n  padding: 16px;\r\n}\r\n\r\n/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */\r\n@media screen and (max-height: 450px) {\r\n  .sidebar {\r\n    padding-top: 15px;\r\n  }\r\n\r\n    .sidebar a {\r\n      font-size: 18px;\r\n    }\r\n}\r\n\r\n\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n  color: #fff;\r\n  background-color: #17a2b8;\r\n  border-color: #dee2e6 #dee2e6 #fff;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n  color: #818182;\r\n}\r\n.card-header {\r\n  padding: 4px 10px 2px 10px;\r\n}\r\n\r\n.card-body {\r\n    padding : 8px !important; \r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
